import { Module } from 'vuex';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';
import { RootState } from '@/store/types';
import { IArticleListState } from '@/store/interfaces';

export const state: IArticleListState = {
  articleList: [],
};

const namespaced = true;

export const articleList: Module<IArticleListState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
